import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment/src/moment'
@Pipe({
    name: 'datetimeformat',
    standalone: false
})
export class DateTimeFormatPipe implements PipeTransform {

  transform(value: any, args?: any): string {
    return moment(value).format('MMM DD, YYYY hh:mm A');
  }

}
